import BlockFeatureSimple from './featureSimple'

export default BlockFeatureSimple
